import type { FaireProductEntity } from "../../entity_types/product";

export const p_ubtu48y4tn: FaireProductEntity = {
  token: "p_ubtu48y4tn",
  type: "product",
  name: "Pansy Cardigan Lilac for Baby & Toddler",
  brandToken: "b_e6gi5qy7n8",
  brandName: "Huggalugs",
  imageUrl:
    "https://cdn.faire.com/fastly/53f1e2007a7f80625ee8cdc9412bfb9ab2a71ae085cfd09dbc8d2deea90752fe.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/02906667c75a96b170f86689a963a259eb6c1439ef19d53b9d7ea21b7324c221.png",
    "https://cdn.faire.com/fastly/0a133d48187879119bd4294c3928a2e06e98e7c900974e669eeef69248defd03.png",
  ],
  priceDollars: 26,
  description:
    "This lilac cardigan takes on an elevated, artisan charm with its delicately crocheted pansies, each one adding a touch of handcrafted beauty. Hand knit from soft, cozy yarn, the sweater is finished with natural wood buttons that lend a warm, timeless feel. Pair it with the coordinating Pansy Beanie to create a refined, heirloom‑worthy look.\n\nOur sweaters are crafted using recycled, sustainable polyester yarn spun from reclaimed plastic bottles, a thoughtful choice that helps lessen global plastic waste. It’s one small way we’re contributing to a cleaner, more sustainable world. ♻️\n\n• Hand Knit\n• 60% Acrylic, 40% Recycled Polyester\n• Hand Wash\n• Designed in our Coachella Valley, CA studio\n",
  tags: [],
  msrpDollars: 52,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:40.461Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
